import * as React from 'react';
import { Button, Card, Header as UIHeader, Modal as UIModal } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { useApiResult } from '~/ApiHooks';
import * as Detail from '~/InfoCard/Details';
import { Sentence } from '~/InfoCard/Sentence';
import { TagLink } from '~/InfoCard/Tag';
import { Placeholder } from '~/UI';
export var Modal = function (_a) {
    var _b, _c, _d;
    var infoCard = _a.infoCard, InfoCardsLink = _a.InfoCardsLink, onClose = _a.onClose;
    var yearMonthTag = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.yearMonth; });
    var yearMonth = React.useState(new Date((_b = yearMonthTag === null || yearMonthTag === void 0 ? void 0 : yearMonthTag.value) !== null && _b !== void 0 ? _b : ''))[0];
    var periodType = Detail.PeriodType.YEAR;
    var _e = React.useState(0), index = _e[0], setIndex = _e[1];
    var period = React.useMemo(function () { return new Detail.Period(new Date(yearMonth), periodType); }, [yearMonth]);
    var detailsRequest = new InfoCardApi.InfoCardDetailsRequest(infoCard.id, period.searchParams);
    var detailsResult = useApiResult(detailsRequest, [infoCard.id, period])[0];
    return (<UIModal open size='fullscreen' onClose={onClose}>
			<UIModal.Content>
				<UIHeader as='h3'>{infoCard.title}</UIHeader>
				<Card.Description>
					{infoCard.tags.map(function (tag) {
            switch (tag.type) {
                case InfoCardApi.TagType.brand:
                case InfoCardApi.TagType.market:
                case InfoCardApi.TagType.source:
                    return <TagLink InfoCardsLink={InfoCardsLink} key={tag.type} tag={tag}/>;
                default:
                    return null;
            }
        })}

					{yearMonthTag !== undefined ? <TagLink InfoCardsLink={InfoCardsLink} tag={yearMonthTag}/> : null}
				</Card.Description>
			</UIModal.Content>
			<UIModal.Content>
				{detailsResult.value === null && detailsResult.isLoading ? <Placeholder /> : null}

				{detailsResult.value !== null && !detailsResult.isLoading ? (<div className='modal-content'>
						{infoCard.sentences.map(function (sentence, i) { return (<Sentence key={i} sentence={sentence}/>); })}
						<Detail.Switcher details={(_d = (_c = detailsResult.value) === null || _c === void 0 ? void 0 : _c.items) !== null && _d !== void 0 ? _d : []} index={index} setIndex={setIndex}/>

						<Detail.Details index={index} infoCardId={infoCard.id} periodType={periodType} yearMonthTag={yearMonth}/>
					</div>) : null}
			</UIModal.Content>
			<UIModal.Actions>
				<Button size='mini' onClick={onClose}>
					Zavřít
				</Button>
			</UIModal.Actions>
		</UIModal>);
};
